import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Configurations } from "../core/configurations";
import { environment } from "../../environments/environment";

import { DizionarioModel } from '../models/shared/dizionario.model';
import { TaglioMonetaModel } from './../models/shared/taglio-moneta.model';

@Injectable()
export class DizionariService {
 
  APITagliMoneta = this.configuration.apiBaseUrlTagliMoneta;
  
  constructor(private http: Http, private configuration: Configurations) {

  }

  getTagliMoneta(): Observable<DizionarioModel[]> {
    return Observable.of(TAGLI_MONETA);
  }

}

const TAGLI_MONETA: TaglioMonetaModel[] = [
  { id: 1, importo: 500 ,   codice: '500', descrizione: 'Banconote da 500€' },
  { id: 2, importo: 200,    codice: '200', descrizione: 'Banconote da 200€' },
  { id: 3, importo: 100,    codice: '100', descrizione: 'Banconote da 100€' },
  { id: 4, importo: 50,     codice: '50', descrizione: 'Banconote da 50€' },
  { id: 5, importo: 20,     codice: '20', descrizione: 'Banconote da 20€' },
  { id: 6, importo: 10,     codice: '10', descrizione: 'Banconote da 10€' },
  { id: 7, importo: 5,      codice: '5', descrizione: 'Banconote da 5€' },
  { id: 8, importo: null,   codice: '',  descrizione: 'Monete' }
];




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/dizionari.service.ts